/**
 * This is a base component for the simple tools components.
 */
export default {
  methods: {
    onControlDone() {
      this.$eventBus.$emit("control-finish", this.controlName);
    },
    onControlCancel() {}
  },
  mounted() {
    this.$eventBus.$on("confirmation-controls:done", this.onControlDone);
    this.$eventBus.$on("confirmation-controls:cancel", this.onControlCancel);
  },
  beforeDestroy() {
    this.$eventBus.$off("confirmation-controls:done", this.onControlDone);
    this.$eventBus.$off("confirmation-controls:cancel", this.onControlCancel);
  }
};
